import { render, staticRenderFns } from "./AuthLayout.vue?vue&type=template&id=222995b0&scoped=true&"
var script = {}
import style0 from "./AuthLayout.vue?vue&type=style&index=0&id=222995b0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "222995b0",
  null
  
)

export default component.exports